import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Popup } from '../../../core/shared/components/popup/popup';
import { TableColumn, TableAction } from '../../shared/models/table-models';
import { Table } from '../../shared/table/table';
import { JournalVoucherService } from '../shared/JournalVoucher.service';
import { TranslatePipe } from '@ngx-translate/core';



@Component({
  selector: 'app-general-voucher',
  standalone: true,
  imports: [CommonModule, Table, Popup, TranslatePipe],
  templateUrl: './general-voucher.html',
  styleUrl: './general-voucher.css',
})
export class GeneralVoucher implements OnInit {

  // ================= LIST =================
  voucherList: any[] = [];
  voucherColumns: TableColumn[] = [];
  voucherActions: TableAction[] = [];

  // ================= DETAILS =================
  voucherDetails: any[] = [];
  detailColumns: TableColumn[] = [];

  showDetailModal = false;
  selectedVoucher: any = {};

  loading = false;

  constructor(private journalService: JournalVoucherService) { }

  ngOnInit(): void {
    this.initTable();
    this.loadVouchers();
  }

  // ================= INIT TABLE =================
  initTable() {

    // MAIN TABLE
    this.voucherColumns = [
      { key: 'voucherId', label: 'GENERAL_VOUCHER.VOUCHER_ID', type: 'text' },
      { key: 'date', label: 'COMMON.DATE', type: 'date' },
      { key: 'description', label: 'COMMON.DESCRIPTION', type: 'text' },
      { key: 'refKey', label: 'GENERAL_VOUCHER.REFERENCE_NUMBER', type: 'text' },
    ];

    this.voucherActions = [
      {
        icon: 'images/view-more.png',   // ✅ your image path
        onClick: (row) => this.openVoucher(row),
        class: 'h-8 w-8 flex items-center justify-center hover:bg-gray-100 rounded-lg',
        tooltip: 'COMMON.VIEW'
      }
    ];

    // DETAIL TABLE (DR / CR)
    this.detailColumns = [
      { key: 'account', label: 'GENERAL_VOUCHER.ACCOUNT', type: 'text' },
      { key: 'description', label: 'COMMON.DESCRIPTION', type: 'text' },
      { key: 'debit', label: 'GENERAL_VOUCHER.DEBIT', type: 'currency' },
      { key: 'credit', label: 'GENERAL_VOUCHER.CREDIT', type: 'currency' },
    ];
  }

  // ================= LOAD LIST =================
loadVouchers(): void {
  this.loading = true;

  this.journalService.getVoucherList().subscribe({
    next: (res: any[]) => {
      const mapped = this.journalService.mapVoucherList(res);

      // ✅ Sort by date (latest first)
      this.voucherList = mapped.sort((a, b) => {
        return new Date(b.date).getTime() - new Date(a.date).getTime();
      });

      this.loading = false;
    },
    error: () => {
      this.voucherList = [];
      this.loading = false;
    }
  });
}

  // ================= OPEN DETAILS =================
  openVoucher(row: any): void {

    this.selectedVoucher = row;
    this.loading = true;

    this.journalService.getVoucherDetails(row.id).subscribe({
      next: (res: any[]) => {
        this.voucherDetails = this.journalService.mapVoucherDetails(res);
        this.showDetailModal = true;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  // ================= TOTAL CALC =================
  get totalDebit(): number {
    return this.voucherDetails.reduce((sum, r) => sum + (r.debit || 0), 0);
  }

  get totalCredit(): number {
    return this.voucherDetails.reduce((sum, r) => sum + (r.credit || 0), 0);
  }

}